export default __webpack_public_path__ + "static/media/building_light.2face26a.png";